document.addEventListener("DOMContentLoaded", function () {
  // Loop through each solutions section (identified by the unique ID)
  document
    .querySelectorAll('[id^="solutions-"]')
    .forEach((solutionsSection) => {
      // console.log(solutionsSection);
      // Filter Items Click Handler
      solutionsSection.querySelectorAll(".-filters .-item").forEach((item) => {
        item.addEventListener("click", function () {
          let filter = this.dataset.item;
          // console.log(filter);

          // Update active state of filter items
          this.parentNode.querySelectorAll(".-item").forEach((sibling) => {
            sibling.classList.remove("active");
          });
          this.classList.add("active");

          // Filter the cards
          solutionsSection.querySelectorAll(".card").forEach((card) => {
            // Correct scoping
            if (filter === "all" || card.dataset.solution === filter) {
              card.style.display = "block";
            } else {
              card.style.display = "none";
            }
          });

          // Update select element
          let defaultSelect = solutionsSection.querySelector(".select select"); // select the select inside the .select
          defaultSelect.value = filter;
          
          // Update URL hash
          if (filter !== "all") {
            window.location.hash = filter;
          } else {
            // Remove hash if "all" is selected
            history.pushState("", document.title, window.location.pathname + window.location.search);
          }
        });
      });

      //Dropdown Listener
      const defaultSelect = solutionsSection.querySelector(".select select");
      defaultSelect.addEventListener("change", function () {
        let filter = this.value;
        solutionsSection.querySelectorAll(".card").forEach((card) => {
          if (filter === "all" || card.dataset.solution === filter) {
            card.style.display = "block";
          } else {
            card.style.display = "none";
          }
        });

        solutionsSection
          .querySelectorAll(".-filters .-item")
          .forEach((item) => {
            item.classList.remove("active");
            if (item.dataset.item == filter) {
              item.classList.add("active");
            }
          });
          
        // Update URL hash
        if (filter !== "all") {
          window.location.hash = filter;
        } else {
          // Remove hash if "all" is selected
          history.pushState("", document.title, window.location.pathname + window.location.search);
        }
      });
      
      // Function to apply filter
      const applyFilter = function(filter) {
        // Update active state of filter items
        solutionsSection.querySelectorAll(".-filters .-item").forEach((item) => {
          item.classList.remove("active");
          if (item.dataset.item === filter) {
            item.classList.add("active");
          }
        });
        
        // Filter the cards
        solutionsSection.querySelectorAll(".card").forEach((card) => {
          if (filter === "all" || card.dataset.solution === filter) {
            card.style.display = "block";
          } else {
            card.style.display = "none";
          }
        });
        
        // Update select element
        const defaultSelect = solutionsSection.querySelector(".select select");
        if (defaultSelect) {
          defaultSelect.value = filter;
        }
      };
      
      // Check for URL hash on page load
      const checkUrlHash = function() {
        if (window.location.hash) {
          const hash = window.location.hash.substring(1); // Remove the # character
          
          // Check if there's a matching filter item
          const hasMatchingItem = Array.from(solutionsSection.querySelectorAll(".-filters .-item")).some(
            item => item.dataset.item === hash
          );
          
          // Check if there's a matching card
          const hasMatchingCard = Array.from(solutionsSection.querySelectorAll(".card")).some(
            card => card.dataset.solution === hash
          );
          
          if (hasMatchingItem || hasMatchingCard) {
            applyFilter(hash);
          }
        }
      };
      
      // Execute hash check on load
      checkUrlHash();
      
      // Listen for hash changes
      window.addEventListener("hashchange", checkUrlHash);
    });

  // Area and Format filters
  const whatsonSection = document.querySelector('#whatson');
  if (whatsonSection) {
    // Area filters
    whatsonSection.querySelectorAll('.-areas .-item').forEach(item => {
      item.addEventListener('click', function() {
        // console.log('area clicked');
        const val_area = this.dataset.area;
        const activeFormat = whatsonSection.querySelector('.-formats .-item.active');
        const val_format = activeFormat ? activeFormat.dataset.format : 'all';
        
        // Update select
        const areaSelect = whatsonSection.querySelector('.-select #area-select');
        if (areaSelect) {
          areaSelect.value = val_area;
          // Trigger change event
          areaSelect.dispatchEvent(new Event('change'));
        }

        // Update active states
        whatsonSection.querySelectorAll('.-areas .-item').forEach(areaItem => {
          areaItem.classList.remove('active');
        });
        this.classList.add('active');

        // Filter cards
        const cards = whatsonSection.querySelectorAll('.-card');
        if (val_area !== 'all') {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
            
            if ((val_format === 'all' && card.dataset.area === val_area) ||
                (card.dataset.format === val_format && card.dataset.area === val_area)) {
              // console.log('area: match');
              card.classList.remove('hide');
              card.classList.add('show');
            }
          });
        } else if ((val_area === 'all' && val_format === 'all') ||
                   (val_area === 'all' && cards[0].dataset.format === val_format)) {
          // console.log('Format matches');
          cards.forEach(card => {
            card.classList.remove('hide');
            card.classList.add('show');
          });
        } else {
          // console.log("format doesn't match");
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
          });
        }

        // Handle warning message
        const warning = whatsonSection.querySelector('.warning');
        const hiddenCards = whatsonSection.querySelectorAll('.result .-card.hide');
        const totalCards = whatsonSection.querySelectorAll('.result .-card');
        
        if (warning) {
          if (hiddenCards.length === totalCards.length) {
            warning.classList.remove('hide');
            warning.classList.add('show');
          } else {
            warning.classList.add('hide');
            warning.classList.remove('show');
          }
        }
      });
    });

    // Area Select Change Handler
    const areaSelect = whatsonSection.querySelector('.-select #area-select');
    if (areaSelect) {
      areaSelect.addEventListener('change', function() {
        const val_area = this.value;
        const activeFormat = whatsonSection.querySelector('.-formats .-item.active');
        const val_format = activeFormat ? activeFormat.dataset.format : 'all';

        // Update active states
        whatsonSection.querySelectorAll('.-areas .-item').forEach(areaItem => {
          areaItem.classList.remove('active');
        });
        const selectedItem = whatsonSection.querySelector(`.-item[data-area="${val_area}"]`);
        if (selectedItem) {
          selectedItem.classList.add('active');
        }

        // Filter cards
        const cards = whatsonSection.querySelectorAll('.-card');
        if (val_area !== 'all') {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
            
            if ((val_format === 'all' && card.dataset.area === val_area) ||
                (card.dataset.format === val_format && card.dataset.area === val_area)) {
              card.classList.remove('hide');
              card.classList.add('show');
            }
          });
        } else if ((val_area === 'all' && val_format === 'all') ||
                   (val_area === 'all' && cards[0].dataset.format === val_format)) {
          cards.forEach(card => {
            card.classList.remove('hide');
            card.classList.add('show');
          });
        } else {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
          });
        }

        // Handle warning message
        const warning = whatsonSection.querySelector('.warning');
        const hiddenCards = whatsonSection.querySelectorAll('.result .-card.hide');
        const totalCards = whatsonSection.querySelectorAll('.result .-card');
        
        if (warning) {
          if (hiddenCards.length === totalCards.length) {
            warning.classList.remove('hide');
            warning.classList.add('show');
          } else {
            warning.classList.add('hide');
            warning.classList.remove('show');
          }
        }
      });
    }

    // Format filters
    whatsonSection.querySelectorAll('.-formats .-item').forEach(item => {
      item.addEventListener('click', function() {
        const val_format = this.dataset.format;
        const activeArea = whatsonSection.querySelector('.-areas .-item.active');
        const val_area = activeArea ? activeArea.dataset.area : 'all';
        
        // Update select
        const formatSelect = whatsonSection.querySelector('.-select #format-select');
        if (formatSelect) {
          formatSelect.value = val_format;
          // Trigger change event
          formatSelect.dispatchEvent(new Event('change'));
        }

        // Update active states
        whatsonSection.querySelectorAll('.-formats .-item').forEach(formatItem => {
          formatItem.classList.remove('active');
        });
        this.classList.add('active');

        // Filter cards
        const cards = whatsonSection.querySelectorAll('.-card');
        if (val_format !== 'all') {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
            
            if ((val_area === 'all' && card.dataset.format === val_format) ||
                (card.dataset.format === val_format && card.dataset.area === val_area)) {
              // console.log('Format: match');
              card.classList.remove('hide');
              card.classList.add('show');
            }
          });
        } else if ((val_area === 'all' && val_format === 'all') ||
                   (val_format === 'all' && card.dataset.area === val_area)) {
          // console.log('Area matches');
          cards.forEach(card => {
            card.classList.remove('hide');
            card.classList.add('show');
          });
        } else {
          // console.log("area doesn't match");
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
          });
        }

        // Handle warning message
        const warning = whatsonSection.querySelector('.warning');
        const hiddenCards = whatsonSection.querySelectorAll('.result .-card.hide');
        const totalCards = whatsonSection.querySelectorAll('.result .-card');
        
        if (warning) {
          if (hiddenCards.length === totalCards.length) {
            warning.classList.remove('hide');
            warning.classList.add('show');
          } else {
            warning.classList.add('hide');
            warning.classList.remove('show');
          }
        }
      });
    });

    // Format Select Change Handler
    const formatSelect = whatsonSection.querySelector('.-select #format-select');
    if (formatSelect) {
      formatSelect.addEventListener('change', function() {
        const val_format = this.value;
        const activeArea = whatsonSection.querySelector('.-areas .-item.active');
        const val_area = activeArea ? activeArea.dataset.area : 'all';

        // Update active states
        whatsonSection.querySelectorAll('.-formats .-item').forEach(formatItem => {
          formatItem.classList.remove('active');
        });
        const selectedItem = whatsonSection.querySelector(`.-item[data-format="${val_format}"]`);
        if (selectedItem) {
          selectedItem.classList.add('active');
        }

        // Filter cards
        const cards = whatsonSection.querySelectorAll('.-card');
        if (val_format !== 'all') {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
            
            if ((val_area === 'all' && card.dataset.format === val_format) ||
                (card.dataset.format === val_format && card.dataset.area === val_area)) {
              card.classList.remove('hide');
              card.classList.add('show');
            }
          });
        } else if ((val_area === 'all' && val_format === 'all') ||
                   (val_format === 'all' && card.dataset.area === val_area)) {
          cards.forEach(card => {
            card.classList.remove('hide');
            card.classList.add('show');
          });
        } else {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
          });
        }

        // Handle warning message
        const warning = whatsonSection.querySelector('.warning');
        const hiddenCards = whatsonSection.querySelectorAll('.result .-card.hide');
        const totalCards = whatsonSection.querySelectorAll('.result .-card');
        
        if (warning) {
          if (hiddenCards.length === totalCards.length) {
            warning.classList.remove('hide');
            warning.classList.add('show');
          } else {
            warning.classList.add('hide');
            warning.classList.remove('show');
          }
        }
      });
    }
  }

  // Industries filter component
  const handleIndustriesFilter = () => {
    // Industries click handler
    document.querySelectorAll('.tpl_whatson .-industries .-item').forEach(item => {
      item.addEventListener('click', function() {
        const val_industry = this.dataset.industry;
        const activeArea = document.querySelector('.-areas .-item.active');
        const val_area = activeArea ? activeArea.dataset.area : 'all';

        // Update select
        const industrySelect = document.querySelector('.-select #industry-select');
        if (industrySelect) {
          industrySelect.value = val_industry;
          // Trigger change event
          industrySelect.dispatchEvent(new Event('change'));
        }

        // Update active states
        document.querySelectorAll('.-industries .-item').forEach(industryItem => {
          industryItem.classList.remove('active');
        });
        this.classList.add('active');

        // Filter cards
        const cards = document.querySelectorAll('.-card');
        if (val_industry !== 'all') {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
            
            if ((val_area === 'all' && card.dataset.industry === val_industry) ||
                (card.dataset.industry === val_industry && card.dataset.area === val_area)) {
              // console.log('Ind: match');
              if (card.dataset.industry === val_industry) {
                card.classList.remove('hide');
                card.classList.add('show');
              }
            }
          });
        } else if ((val_area === 'all' && val_industry === 'all') ||
                   (val_industry === 'all' && document.querySelector('.-card').dataset.area === val_area)) {
          // console.log('area matches');
          cards.forEach(card => {
            card.classList.remove('hide');
            card.classList.add('show');
          });
        } else {
          // console.log("area doesn't match");
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
          });
        }

        // Handle warning message
        const warning = document.querySelector('.warning');
        const hiddenCards = document.querySelectorAll('.result .-card.hide');
        const totalCards = document.querySelectorAll('.result .-card');
        
        if (warning) {
          if (hiddenCards.length === totalCards.length) {
            warning.classList.remove('hide');
            warning.classList.add('show');
          } else {
            warning.classList.add('hide');
          }
        }
      });
    });

    // Industries select change handler
    const industrySelect = document.querySelector('.-select #industry-select');
    if (industrySelect) {
      industrySelect.addEventListener('change', function() {
        const val_industry = this.value;
        const activeArea = document.querySelector('.-areas .-item.active');
        const val_area = activeArea ? activeArea.dataset.area : 'all';

        // Update active states
        document.querySelectorAll('.-industries .-item').forEach(industryItem => {
          industryItem.classList.remove('active');
        });
        const selectedItem = document.querySelector(`.-item[data-industry="${val_industry}"]`);
        if (selectedItem) {
          selectedItem.classList.add('active');
        }

        // Filter cards
        const cards = document.querySelectorAll('.-card');
        if (val_industry !== 'all') {
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
            
            if ((val_area === 'all' && card.dataset.industry === val_industry) ||
                (card.dataset.industry === val_industry && card.dataset.area === val_area)) {
              // console.log('Ind: match');
              if (card.dataset.industry === val_industry) {
                card.classList.remove('hide');
                card.classList.add('show');
              }
            }
          });
        } else if ((val_area === 'all' && val_industry === 'all') ||
                   (val_industry === 'all' && document.querySelector('.-card').dataset.area === val_area)) {
          // console.log('area matches');
          cards.forEach(card => {
            card.classList.remove('hide');
            card.classList.add('show');
          });
        } else {
          // console.log("area doesn't match");
          cards.forEach(card => {
            card.classList.remove('show');
            card.classList.add('hide');
          });
        }

        // Handle warning message
        const warning = document.querySelector('.warning');
        const hiddenCards = document.querySelectorAll('.result .-card.hide');
        const totalCards = document.querySelectorAll('.result .-card');
        
        if (warning) {
          if (hiddenCards.length === totalCards.length) {
            warning.classList.remove('hide');
            warning.classList.add('show');
          } else {
            warning.classList.add('hide');
          }
        }
      });
    }
  };

  // Initialize industries filter
  handleIndustriesFilter();

  // Toggle all speakers
  const showAllSpeakers = document.querySelector("#showall_speakers");
  if (showAllSpeakers) {
    showAllSpeakers.addEventListener("click", function() {
      document.querySelectorAll(".el-speakers__grid-card .-card").forEach(card => {
        card.classList.remove("hide");
        card.classList.add("show");
      });
      this.classList.add("hide");
    });
  }

  // Toggle tier sponsors
  document.querySelectorAll(".showall").forEach(showAll => {
    showAll.addEventListener("click", function() {
      const el = this.getAttribute("data-toggle");
      const cards = document.querySelectorAll(`${el} .-card`);
      console.log(`${el} .-card`);
      cards.forEach(card => {
        card.classList.remove("hide");
        card.classList.add("show");
      });
      this.classList.add("hide");
    });
  });

  // Toggle tooltips
  document.querySelectorAll(".-tooltip").forEach(tooltip => {
    tooltip.addEventListener("click", function() {
      const obj = this.dataset.obj;
      document.querySelector(obj)?.classList.toggle("hide");
    });
  });
  
});